export const hasOnlyPaginationFilters = (allFilters: Record<string, any>, allowedFilters: string[] = []) =>
  Object.entries(allFilters).filter(([k, v]) => v && !["offset", "limit", ...allowedFilters].includes(k))?.length === 0;
